export default __webpack_public_path__ + "static/media/MySQL.3175fdd1.svg";